<template>
  <div>
    <under-development/>
    <!-- Desktop -->
    <v-container class="pa-4" fluid v-if="$vuetify.breakpoint.mdAndUp">
      <v-row dense>
        <v-col class="col-md-6 col-lg-4 pa-0 pr-4 pl-4">
          <v-container class="pa-0" fluid>
            <v-row>
              <v-col class="col-12 pa-0">
                <desktop-card-single title="Filter" class="pa-0">
                  <template v-slot:content>
                    <v-select :items="metaTitles" label="select meta" solo v-if="metaListLoaded" v-model="selectedMeta" @change="getMetaDeckData"/>
                    <v-select :items="metaIdentities" label="select identity" solo v-if="metaDecksLoaded" v-model="selectedIdentity" @change="getArchetypes"/>
                  </template>
                </desktop-card-single>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col class="col-md-6 col-lg-8 pa-0 pl-2">
          <v-row>
              <v-col class="col-12 pa-0">
                <desktop-card-single title="Archetypes" class="pa-0">
                  <template v-slot:content>
                  </template>
                </desktop-card-single>
              </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import UnderDevelopment from '@/components/widget/UnderDevelopment'
import DesktopCardSingle from '@/components/header/DesktopCardSingle.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Archetypes',
  components: {
    UnderDevelopment,
    DesktopCardSingle
  },
  data: function () {
    return {
      selectedMeta: '',
      selectedIdentity: '',
      metaDecksLoaded: false,
      minimumDeckCount: 3 // ID has decks at minimum
    }
  },
  mounted () {
    if (this.metaListLoaded) this.initDeckData()
  },
  methods: {
    initDeckData: function () {
      this.selectedMeta = this.metaTitles[0]
      this.getMetaDeckData()
    },
    getMetaDeckData: function () {
      const metacode = this.metas.metaList.find(x => x.title === this.selectedMeta).code
      console.log('getting decks for meta code:', metacode)
      this.metaDecksLoaded = false
      this.$store.dispatch('metas/getMetaDeckData', metacode).then((response) => {
        // this.runnerDeckHighlights = clustering.processMeta(this.metaDecks.runner).filter(x => x.successScore > this.minSuccessScore)
        // this.corpDeckHighlights = clustering.processMeta(this.metaDecks.corp).filter(x => x.successScore > this.minSuccessScore)
        this.metaDecksLoaded = true
        this.$store.commit('metas/setCurrentMetaCode', metacode)
        this.selectedIdentity = this.metaIdentities[1]
        this.getArchetypes()
      })
    },
    getArchetypes: function () {
      console.log('getting archetypes:', this.selectedIdentity)
    }
  },
  watch: {
    'metas.metaList': function (newValue, oldValue) {
      this.selectedMeta = this.initDeckData()
    }
  },
  computed: {
    ...mapState(['metas']),
    ...mapGetters({
      metaDecks: 'metas/getCurrentMetaDecks'
    }),
    metaListLoaded: function () {
      return this.metas && this.metas.metaList && this.metas.metaList.length > 0
    },
    metaTitles: function () {
      if (!this.metaListLoaded) return []
      return this.metas.metaList.map(x => x.title)
    },
    metaRunnerIdentities: function () {
      if (!this.metaDecks) return []
      return this.metaDecks.runner.filter(x => x.deckCount >= this.minimumDeckCount).map(x => `${x.identity.title} (${x.deckCount})`)
    },
    metaCorpIdentities: function () {
      if (!this.metaDecks) return []
      return this.metaDecks.corp.filter(x => x.deckCount >= this.minimumDeckCount).map(x => `${x.identity.title} (${x.deckCount})`)
    },
    metaIdentities: function () {
      return [{ header: 'Runners' }].concat(this.metaRunnerIdentities, [{ header: 'Corporations' }], this.metaCorpIdentities)
    }
  }
}
</script>
